import React from 'react';
import { motion } from 'framer-motion';
export function InfraestructuraSistemica() {
  return <section className="bg-transparent text-[#2d2d2d] overflow-hidden pb-[0px]" data-id="element-244">
      <div className="max-w-5xl mx-auto px-4 pl-[0px] pr-[0px]" data-id="element-245">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="w-full" data-id="element-246">
          <img src="https://cdn.magicpatterns.com/uploads/38gGVTjS3zH64ySYM3jjwP/ChatGPT_Image_10_may_2026,_13_11_28.webp" alt="Infraestructura del Aprendizaje en Tarot Terapéutico" className="w-full h-auto" data-id="element-247" />
        </motion.div>
      </div>
    </section>;
}